import { fetchWithAuth } from '../auth'

export async function getManagerDashboard() {
  const resp = await fetchWithAuth(
    `${process.env.REACT_APP_ICC_TOOL_API_HOST}manager/dashboard/`,
    { credentials: 'include' }
  )
  if (!resp.ok) throw new Error('Failed to fetch manager dashboard')
  return resp.json()
}

export async function getTeamDetail(teamId) {
  const resp = await fetchWithAuth(
    `${process.env.REACT_APP_ICC_TOOL_API_HOST}manager/dashboard/${teamId}/`,
    { credentials: 'include' }
  )
  if (!resp.ok) throw new Error(`Failed to fetch details for team ${teamId}`)
  return resp.json()
}
